class TMv_NewsPostRecent {

	showing = 1;
	num_items = 0;
	timer_ms = 3000; // milliseconds between each one
	main_timeout = null;

	constructor(element, params)
	{
		this.element = element;

		// Save the number of buttons we have
		this.num_items = this.element.querySelectorAll('.post_details').length;


		// Event listeners for left/right button
		this.element.querySelector('#showcase_control_left').addEventListener('click',this.showPrevious.bind(this));
		this.element.querySelector('#showcase_control_right').addEventListener('click',this.showNext.bind(this));

		// Listen on the individual buttons
		this.element.querySelectorAll('.controls .news_post_button').forEach(el => {
			el.addEventListener('click', this.newsPostControlClick.bind(this));
		});


		// Show the first one
		this.showItemNumber(1);

		// Start the timer
		this.startAutoScroll();


	}

	/**
	 * Handles when a project control button is clicked
	 * @param event
	 */
	newsPostControlClick(event) {

		event.preventDefault();
		let button = event.currentTarget;
		let num = button.getAttribute('data-num');
		//console.log('click on ', num);
		//console.log(button);
		this.showing = num;
		this.showItemNumber(num);

		// Reset the timer, we picked out of order
		this.restartTimeout();

		//console.log('Click ', num);
	}

	/**
	 * Shows the next one
	 */
	showNext(event = null) {

		//console.log('showNext');
		// Prevent default if the event exists
		event?.preventDefault();

		// Increase the counter
		this.showing++;
		if(this.showing > this.num_items )
		{
			//console.log('resetting to the first');
			this.showing = 1;
		}

		this.showItemNumber(this.showing);

		// If there was an event, then it was a click and we should restart the timeout
		if(event) {
			console.log('inside event exists');
			this.restartTimeout();
		}
		//console.log('showNext complete ', this.showing);
	}

	/**
	 * Shows the previous item
	 * @param {Event} event
	 */
	showPrevious(event = null) {

		// Prevent default if the event exists
		event?.preventDefault();

		// Decrease the counter
		this.showing--;
		if(this.showing == 0 ) {
			this.showing = this.num_items;
		}

		this.showItemNumber(this.showing);

		// Previous always triggers a new timer, since we went backwards
		this.restartTimeout();

	}


	/**
	 * Straight swap to the nearest one
	 * @param num
	 */
	showItemNumber(num) {
		//console.log('showItemNumber', num);
		// Hide the current one, then show the new one
		this.element.querySelectorAll('.post_details, .post_photo').forEach(el => {el.hide()});
		this.showing = num;
		this.element.querySelector('.post_details_container .post_'+this.showing).show();
		this.element.querySelector('.post_photos .post_'+this.showing)?.show();

		// Update the controls
		this.element.querySelector('.controls .showing').classList.remove('showing');
		this.element.querySelector('.controls .control_'+this.showing).classList.add('showing');

	}



	/**
	 * Creates a timeout closure that allows us to trigger and clear timeouts with more control
	 * @param timeoutHandler
	 * @param delay
	 * @returns {{clear: clear, trigger: (function(): *)}}
	 * @see https://stackoverflow.com/questions/7689233/force-settimeout-to-fire-its-payload-earlier-than-originally-set
	 */
	createTimeout(timeoutHandler, delay) {
		let timeout_id;
		timeout_id = setInterval(timeoutHandler, delay);
		return {
			clear: () => {
				clearTimeout(timeout_id);
			},
			trigger: () => {
				clearTimeout(timeout_id);
				return timeoutHandler();
			}
		};
	}

	/**
	 * Restarts the timeout, clearing out any previous ones that might have existed, starting a new one
	 */
	restartTimeout() {
		//console.log('restartTimeout');
		this.main_timeout?.clear(); // clears if exists
		this.main_timeout = null;
		this.startAutoScroll();
	}

	/**
	 * Starts the auto scroll of the next one
	 */
	startAutoScroll() {
		this.main_timeout = this.createTimeout(() => {
			this.showNext(null);
		}, this.timer_ms);
	}
}